import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import { formatGraphqlErrors } from 'utils/helpers';
import {
  ContactMessagesDocument,
  SendFeedbackDocument,
  type SendFeedbackMutationVariables,
} from 'graphql/generated/graphql';

const useSendFeedback = () => {
  const [sendFeedbackMutation] = useMutation(SendFeedbackDocument);

  const handleSubmit = useCallback(
    /** The mutation's answer: false when the answer was saved but no email went out (a guest without an email). */
    async (variables: SendFeedbackMutationVariables, page: number) => {
      try {
        const { data } = await sendFeedbackMutation({
          variables,
          refetchQueries: [
            {
              query: ContactMessagesDocument,
              variables: { offset: COUNT_TABLE_RECORDS * (page - 1), limit: COUNT_TABLE_RECORDS },
            },
          ],
        });
        return data?.sendFeedback ?? null;
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [sendFeedbackMutation],
  );

  return handleSubmit;
};

export default useSendFeedback;
